// extracted by mini-css-extract-plugin
export default {"Container":"bXHrYBesxAM4WsNIBXAY","Head":"tZSdo0TsG8Y8vvUXmRUs","Heading":"R6ynOkTbEIQ_rWp4r96k","Body":"dQFb_0eA5EC5DJe1nlMw","Footer":"W_6PEi41AhVYf4S_wLGp"};